import {SELLER_TYPE} from './sellertypes';

const UK_COUNTRY_CODE = 'GB';
const EURO_CURRENCY_CODE = 'EUR';

const determineIsTrader = (
  showBrokerInfoDSA,
  showBrokerInfo,
  isCMA,
  isDSA,
  isDsaAccepted,
  sellerType,
  eventCountry = '',
  eventCurrency = ''
) => {
  if (eventCountry === UK_COUNTRY_CODE && eventCurrency === EURO_CURRENCY_CODE) {
    return false;
  }

  if (showBrokerInfoDSA) {
    // New logic
    if (showBrokerInfo) {
      // CMA
      if (sellerType === SELLER_TYPE.BUSINESS) {
        return true;
      }

      return isCMA && sellerType === SELLER_TYPE.TRADER;
    }
    // DSA
    if (sellerType === SELLER_TYPE.BUSINESS) {
      return isDsaAccepted;
    }

    if (sellerType === SELLER_TYPE.TRADER) {
      return isDsaAccepted && isDSA;
    }

    return false;
  }

  // Old logic
  return showBrokerInfo && (sellerType === SELLER_TYPE.BUSINESS || sellerType === SELLER_TYPE.TRADER);
};

export {determineIsTrader};
